import {ref, Ref, watch} from 'vue';
import {ErrorsNotifier} from '../../../core/error/ErrorsNotifier';

export class EditorCurrentUserControllerClass {
	private static _instance: EditorCurrentUserControllerClass;
	static instance() {
		return (this._instance = this._instance || new EditorCurrentUserControllerClass());
	}

	private _username: Ref<string | null> = ref(null);
	private constructor() {
		watch(this._username, () => {
			ErrorsNotifier.updateMetadata();
		});
	}

	username() {
		return this._username;
	}

	setUsername(username: string) {
		this._username.value = username;
	}
}

export const EditorCurrentUserController = EditorCurrentUserControllerClass.instance();
